module.exports = __webpack_public_path__ + "static/quickstart-4-ba3acffd684e6ca243491884b4b1626b.png";